import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import ProductFiles from './ProductFiles';

const ChangePrioritiesMutation = gql`
    mutation changePriorities($imagesToChange: [PrioritiesInput!]!) {
        changePriorities(imagesToChange: $imagesToChange)
    }
`;

export default compose(graphql<any, Response>(ChangePrioritiesMutation, { 
    name: 'changePriorities' 
}))(ProductFiles);



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductFilesTab/ProductFiles/index.ts